import { ContentType } from '@entries/content-types'
import ContentfulPageSectionTabsDesktop from '@entries/contentful-page-section-tabs-desktop'
import ContentfulPageSectionTabsMobile from '@entries/contentful-page-section-tabs-mobile'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulPageSectionTabs: Utils.EntryFC<
  Queries.ContentfulPageSectionTabsFragment
> = ({ content }) => (
  <>
    <div className="hidden laptop:block">
      <Entry
        content={content}
        mapping={{
          [ContentType.ContentfulPageSection]: ContentfulPageSectionTabsDesktop,
        }}
      />
    </div>
    <div className="block laptop:hidden">
      <Entry
        content={content}
        mapping={{
          [ContentType.ContentfulPageSection]: ContentfulPageSectionTabsMobile,
        }}
      />
    </div>
  </>
)

export const query = graphql`
  fragment ContentfulPageSectionTabs on ContentfulSection {
    ...ContentfulEntry
    ...ContentfulPageSectionTabsDesktop
    ...ContentfulPageSectionTabsMobile
  }
`

export default withDisplayName(
  ContentfulPageSectionTabs,
  'ContentfulPageSectionTabs'
)
